import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import Error from '../Components/Error/Errorcode';
import Breadcrumbs from '../Components/banner/New-banner';
function Errorpage (){
    return(
        <>
        <Combaintop/>
        <Breadcrumbs/>
        <Error/>
        <Combainbottom/>
        </>
    );
}

export default Errorpage;